module.exports = __webpack_public_path__ + "asset/image-dashboard-screenshot-9a768ccab871ce99.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/dashboard-screenshot.png
// module id = t2Si
// module chunks = 1